import styled from 'styled-components';

// Os passos do fluxo foram feitos para a página cheia (margem do header, container centralizado,
// py-5/mt-5 e col-md-9 + col-md-3). No painel, como no protótipo: fundo cinza, conteúdo flexível
// e o indicador de passos numa coluna de 220px à direita.
export const Container = styled.div`
  min-height: 100%;
  background: #f8f9fa;
  padding: 32px 40px 48px;

  .page-container {
    margin: 0;
  }

  .page-container > .container-fluid,
  .page-container > .container {
    width: 100% !important;
    max-width: 100%;
    margin: 0;
    padding: 0 !important;
  }

  .page-container > .container-fluid > .row,
  .page-container > .container > .row {
    margin-top: 0 !important;
  }

  .page-container .row.align-items-stretch {
    flex-wrap: nowrap;
    gap: 32px;
    margin-left: 0;
    margin-right: 0;
  }

  .page-container .row.align-items-stretch > .col-md-9 {
    flex: 1 1 auto;
    max-width: none;
    min-width: 0;
    padding: 0;
  }

  .page-container .row.align-items-stretch > .col-md-3 {
    flex: 0 0 220px;
    max-width: 220px;
    padding: 0;
  }
`;
